import type { ReactNode } from 'react';
import { useState } from 'react';

interface TooltipProps {
  content: string;
  children: ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

const positionStyle: Record<string, React.CSSProperties> = {
  top:    { bottom: 'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)' },
  bottom: { top:    'calc(100% + 6px)', left: '50%', transform: 'translateX(-50%)' },
  left:   { right:  'calc(100% + 6px)', top:  '50%', transform: 'translateY(-50%)' },
  right:  { left:   'calc(100% + 6px)', top:  '50%', transform: 'translateY(-50%)' },
};

export default function Tooltip({ content, children, position = 'top' }: TooltipProps) {
  const [visible, setVisible] = useState(false);
  return (
    <span
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
    >
      {children}
      {visible && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            ...positionStyle[position],
            background: 'var(--navy)',
            color: '#fff',
            fontSize: '11px',
            fontWeight: 600,
            padding: '4px 8px',
            borderRadius: '6px',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
            zIndex: 'var(--z-dropdown)' as unknown as number,
            boxShadow: 'var(--shadow-md)',
          }}
        >
          {content}
        </span>
      )}
    </span>
  );
}
